
const handleEventDispatcherLayerClick = ( ctx, event ) => {
    const { feature } = event.detail;

    const eventName = feature.properties.event;
    const eventDetail = JSON.parse( feature.properties.eventDetail || '{}' ) || {};

    ctx.root.dispatchEvent( new CustomEvent( eventName, {
        bubbles: true,
        detail: {
            originalEvent: event,
            feature: feature,
            ...eventDetail,
        },
    } ) );
};

export {
    handleEventDispatcherLayerClick,
};
